import React from "react";
import SectionHeading from "../../SectionHeading";
import { Icon } from "@iconify/react";

export default function GallerySection({ sectionTitle, sectionTitleUp, data }) {
  return (
    <div className="container">
      <div style={{ marginBottom: "40px" }}>
        <SectionHeading title={sectionTitle} titleUp={sectionTitleUp} />
      </div>

      <div className="cs_mcp_gallery_grid">
        {data?.map((item, index) => (
          <div className="cs_mcp_gallery_card" key={index}>
            <div className="cs_mcp_gallery_img_wrapper">
              <img src={item.imgUrl} alt={item.alt || "Gallery"} className="cs_mcp_gallery_img" />
              <span className="cs_mcp_link_hover">
                <i>
                  <Icon icon="fa6-solid:arrows-up-down-left-right" />
                </i>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
